import { api } from '@/core/api/';

const URL = 'api/contract';

export const getInitFilters = () => api.get(`${URL}/initfilters`);

export const getProviders = (academicYearId) =>
  api.get(`${URL}/providers/${academicYearId}`);

export const searchContracts = (payload) =>
  api.get(`${URL}/searchcontracts`, {
    params: {
      ...payload,
    },
  });

export const searchRequestServices = (payload) =>
  api.get(`${URL}/searchrequestservices`, {
    params: {
      ...payload,
    },
  });

export const getContractServiceInfo = (
  companyId,
  requestServiceId,
  contractId
) =>
  api.get(`${URL}/contractserviceinfo/${companyId}/${requestServiceId}`, {
    params: {
      contractId,
    },
  });

export const getContractServiceSpecialistsValidity = (
  requestServiceId,
  contractId
) =>
  api.get(
    `${URL}/contractserviceinfo/specialits/validity/${requestServiceId}/${contractId}`
  );

export const getProviderLocationTypes = (companyId, academicYearId) =>
  api.get(`${URL}/providerlocationtypes/${companyId}/${academicYearId}`);

export const getProviderMunicipalities = (
  companyId,
  academicYearId,
  locationTypeId
) =>
  api.get(
    `${URL}/providermunicipalities/${companyId}/${academicYearId}/${locationTypeId}`
  );

export const getProviderLocations = (
  companyId,
  academicYearId,
  locationTypeId,
  municipalityId
) =>
  api.get(
    `${URL}/providerlocations/${companyId}/${academicYearId}/${locationTypeId}/${municipalityId}`
  );

export const saveOrUpdateContract = (payload) =>
  api.post(`${URL}/saveorupdatecontract`, payload, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });

export const submitContract = (payload) =>
  api.post(`${URL}/submitcontract`, payload, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });

export const getSpecialists = (disciplineTypeId, locationFiscalYearId) =>
  api.get(`${URL}/specialists/${disciplineTypeId}/${locationFiscalYearId}`);

export const getSpecialistSupervisors = (companyId, academicId, specialistId) =>
  api.get(`${URL}/supervisors/${companyId}/${academicId}/${specialistId}`);

export const getContractInformation = (
  companyId,
  requestServiceId,
  contractId,
  payload
) =>
  api.get(
    `${URL}/contractInformation/${companyId}/${requestServiceId}/${contractId}`,
    {
      params: {
        ...payload,
      },
    }
  );

export const saveContractDocument = (payload) =>
  api.post(`${URL}/savecontractdocument`, payload, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });

export const getContractDocuments = (peiId, requestServiceId, contractId) =>
  api.get(`${URL}/contractdocuments`, {
    params: {
      peiId,
      requestServiceId,
      contractId,
    },
  });

export const getRelatedContractDocuments = (contractId) =>
  api.get(`${URL}/parentdocuments/${contractId}`);

export const deleteContractDocument = (contractId, contractDocumentTypeId) =>
  api.delete(`${URL}/deletecontractdocument`, {
    params: {
      contractId,
      contractDocumentTypeId,
    },
  });

export const deleteAdditionalContractDocument = (contractDocumentId) =>
  api.delete(`${URL}/deleteadditionalcontractdocument/${contractDocumentId}`);

export const returnToNewStatus = (payload) =>
  api.post(`${URL}/returntonewstatus`, payload);

export const getContractStatusHistory = (contractId, pageIndex, pageSize) =>
  api.get(`${URL}/contractstatushistory/${contractId}`, {
    params: {
      pageIndex,
      pageSize,
    },
  });

export const signContract = (payload) =>
  api.post(`${URL}/signcontract`, payload, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });

export const getDeterminationReasonsByStatus = (statusId) =>
  api.get(`${URL}/determinationreasonsbystatus/${statusId}`);

export const updateContractStatus = (payload) =>
  api.post(`${URL}/updatecontractstatus`, payload, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });

export const getContractHistory = (contractId, pageIndex, pageSize) =>
  api.get(`${URL}/contracthistory`, {
    params: {
      contractId,
      pageIndex,
      pageSize,
    },
  });

export const returnToPreviousStatus = (payload) =>
  api.post(`${URL}/returntopreviousstatus`, payload);

export const addOrUpdateContractServiceStartDate = (payload) =>
  api.post(`${URL}/addorupdatecontractservicestartdate`, payload);

export const getAmendmentReasons = (contractId) =>
  api.get(`${URL}/amendmentreasons/`, { params: { contractId } });

export const amendContract = (payload) =>
  api.post(`${URL}/amendcontract`, payload, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });

export const modifyApprovalDate = (payload) =>
  api.post(`${URL}/modifyapprovaldate`, payload);

export const saveEvaluationDocuments = (payload) =>
  api.post(`${URL}/saveevaluationdocuments`, payload, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });

export const getEvaluationDocuments = (
  contractId,
  disciplineTypeId,
  studentSieId
) =>
  api.get(`${URL}/evaluationdocuments/${contractId}/${disciplineTypeId}`, {
    params: {
      studentSieId,
    },
  });

export const getMinAndMaxContractServiceStartDate = (payload) =>
  api.get(`${URL}/minandmaxcontractservicestartdate`, {
    params: {
      ...payload,
    },
  });

export const getContractAmendmentReasons = (contractId) =>
  api.get(`${URL}/contractamendmentreasons/${contractId}`);

export const getContractSpecialists = (contractId) =>
  api.get(`${URL}/searchcontractspecialists/${contractId}`);

export const getContractHeaderInfo = (contractId) =>
  api.get(`${URL}/contractheaderinfo/${contractId}`);

export const getProviderContractIds = (companyId) =>
  api.get(`${URL}/providercontractids/${companyId}`);

export const getContractById = (contractId, monthNumber, yearNumber) =>
  api.get(`${URL}/getcontract/${contractId}/${monthNumber}/${yearNumber}`);

export const getAdditionalsDocumentTypes = () =>
  api.get(`${URL}/additionalsdocumenttypes`);

export const getAdditionalContractDocuments = (contractId, academicYearId) =>
  api.get(
    `${URL}/additionalscontractdocuments/${contractId}/${academicYearId}`
  );

export const getContractDocumentsHistory = (contractId, academicYearId) =>
  api.get(`${URL}/contractdocumentshistory/${contractId}/${academicYearId}`);

export const getContractVisitInfo = (contractId) =>
  api.get(`${URL}/contractvisitinfo/${contractId}`);

export const saveCost = (contractId, cost) =>
  api.put(`${URL}/${contractId}/cost`, {
    cost,
  });

export const saveContractor = (contractId, contractor) =>
  api.put(`${URL}/${contractId}/contractor`, {
    contractor,
  });

export const saveTransportationCost = (contractId, transportationCost) =>
  api.put(`${URL}/${contractId}/transportationCost`, {
    transportationCost,
  });

export const getBalanceOfTherapyCompensatory = (
  contractId,
  searching = false
) =>
  api.get(
    `${URL}/balanceoftherapycompensatory/${contractId}?searching=${searching}`
  );

export const saveEvaluationDiscussion = (payload) =>
  api.post(`${URL}/saveevaluationdiscussion`, payload, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });

export const getSpecialistLicenseDocuments = (specialistId) =>
  api.get(
    `${URL}/specialistlicensedocuments?specialistId=${specialistId.join(
      '&specialistId='
    )}`
  );

export const getContractIdByContractNumber = (companyId, contractNumber) =>
  api.get(`${URL}/contractidbycontractnumber/${companyId}/${contractNumber}`);

export const replaceEvaluationDocument = (
  contractId,
  studentEvaluationId,
  payload
) =>
  api.post(
    `${URL}/replaceevaluationdocument/${contractId}/${studentEvaluationId}`,
    payload,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    }
  );

export const updateDate = (payload) =>
  api.post(`${URL}/updateDate`, payload, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });

export const getSignaturesProvider = (companyId, contractId) =>
  api.get(`${URL}/signaturesProvider/${companyId}/${contractId}`);

export const getUserInformation = (userId) =>
  api.get(`api/rp/profile/${userId}`);

export const updateSignatureContractorInfo = (contractId, userId) =>
  api.put(`${URL}/updatesignaturecontractorinfo`, {
    contractId,
    userId,
  });

export const getSignaturesTeacher = (
  academicYearId,
  studentSchoolId,
  studentSieId
) =>
  api.get(
    `${URL}/signaturesTeacher/${academicYearId}/${studentSchoolId}/${studentSieId}`
  );

export const getSignaturesDirector = (schoolId, contractId) =>
  api.get(`api/rp/signaturesDirector/${schoolId}/${contractId}`);

export const getTeachers = (studentSchoolId) =>
  api.get(`${URL}/teachers/${studentSchoolId}`);

export const getProviderSelected = (contractId) =>
  api.get(`${URL}/providerSelected/${contractId}`);

export const getStudentLocations = (academicYearId) =>
  api.get(`${URL}/studentLocations/${academicYearId}`);

export const validateContractForSign = (contractId) =>
  api.get(`${URL}/validateContractForSign/${contractId}`);

export const saveExceedCost = (payload) =>
  api.post(`${URL}/cost`, payload, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });

export const getContractCostChangeHistory = (contractId, pageIndex, pageSize) =>
  api.get(`${URL}/contractcostchangehistory/${contractId}`, {
    params: {
      pageIndex,
      pageSize,
    },
  });

export const saveInterventionServiceInformation = (payload) =>
  api.post(`${URL}/saveinterventionserviceinformation`, payload, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });

export const cancelContractElectronicSignature = (contractId, payload) =>
  api.post(`${URL}/${contractId}/cancelelectronicsignature`, payload);
